import Bus from "@/lib/Bus"
const bus: Bus = new Bus().getBus();
import { IWykrojnikRow } from "./IWykrojnikRow";
import {IWykrojnikSvc,wykrojnik_api} from "./IWykrojnikSvc"
import { Request, Response, Express } from "express";

export class WykrojnikSvc implements IWykrojnikSvc {

   

    public async save_selected_wykrojnik_for_tree(param:IWykrojnikRow):Promise<IWykrojnikRow | undefined> {
        console.log("save_selected_wykrojnik_for_tree",param)
        const ret = await bus.call(wykrojnik_api.save_selected_wykrojnik_for_tree,param);
        if (ret && ret._id) {
            wykrojnik_api.selected = ret;
            console.log("save_selected_wykrojnik_for_tree",ret)
            return (<IWykrojnikRow> ret);
        }
        else return undefined
    }

    public async save_manual_wykrojnik_for_tree(param:IWykrojnikRow):Promise<IWykrojnikRow | undefined> {
        const ret = await bus.call(wykrojnik_api.save_manual_wykrojnik_for_tree,param);
        if (ret && ret._id) {
            return (<IWykrojnikRow> ret);
        }
        else return undefined
    }


    public async  get_selected_wykrojnik_for_tree(tree_id:string):Promise<IWykrojnikRow | undefined> {
        const ret = await bus.call(wykrojnik_api.get_selected_wykrojnik_for_tree,{ tree_id: tree_id });
        if (ret && ret._id) {
            wykrojnik_api.selected = ret;
            console.log("get_selected_wykrojnik_for_tree",ret)
            return (<IWykrojnikRow> ret);
        }
        else return undefined
    }

    public async  del_selected_wykrojnik_for_tree(tree_id:string):Promise<IWykrojnikRow | undefined> {
        const ret = await bus.call(wykrojnik_api.del_selected_wykrojnik_for_tree,{ tree_id: tree_id });
        if (ret && ret._id) {
            wykrojnik_api.selected = ret;
            console.log("del_selected_wykrojnik_for_tree",ret)
            return (<IWykrojnikRow> ret);
        }
        else return undefined
    }

}
      
  